import { isBrowser } from '@/utils/environment';

export function useIsRetina() {
  if (!isBrowser()) return false;
  return window.devicePixelRatio && window.devicePixelRatio >= 2;
}
